// ============================================================
// ANSICHTSSACHE-AGENT – Marke (Tag)
// ============================================================
// Ein NAME, den jemand vergeben hat — keine Lage, kein Zustand.
// Die Kostenart ist der Fall, an dem das Bauteil entstanden ist:
// sie trug vorher das Kennzeichen (`Badge`), also 10 Pixel,
// Versalien, gesperrt — und las sich in der Ausgabenliste wie
// „BEZAHLT" und „ÜBERFÄLLIG" daneben. Zwei verschiedene Dinge in
// derselben Form sind eine falsche Auskunft: der Zustand einer
// Zeile aendert sich von selbst, ihre Kostenart hat jemand
// hingeschrieben.
//
// Darum die Marke: gemischte Schreibung in Lesegroesse, runde
// Kapsel, blasser Grund. Sie soll sich wiedererkennen lassen —
// dieselbe Form in der Ausgabenliste, im Kontoauszug, im Budget
// und in dem Feld, aus dem gewaehlt wird.
//
// ZWEI FASSUNGEN, und der Unterschied ist die Linie:
//
//   GESETZT — durchgezogene Kante. Der Name steht so in der
//   Datenbank.
//
//   VORGESCHLAGEN (`vorschlag`) — gestrichelte Kante. Das
//   Gedaechtnis, die Starttabelle oder das Modell haelt ihn fuer
//   richtig, gebucht ist er nicht. Eine gestrichelte Linie sagt
//   „noch nicht verbindlich", ohne ein Wort dafuer zu brauchen.
// ============================================================

import { cn } from "@/lib/utils";
import { categoryLabel } from "@/lib/expense-categories";

export function Tag({
  children,
  /** Noch nicht gebucht — gestrichelte Kante statt durchgezogener. */
  vorschlag,
  title,
  className,
}: {
  children: React.ReactNode;
  vorschlag?: boolean;
  title?: string;
  className?: string;
}) {
  return (
    <span
      title={title}
      className={cn(
        // `max-w-full` und `truncate`: auch eine Marke bleibt in
        // ihrer Zeile — „Berufsgenossenschaft" darf die Spalte
        // nicht aufziehen.
        "text-caption inline-flex max-w-full items-center truncate rounded-full border px-2 py-0.5",
        // Beide Fassungen tragen eine Linie, nur eine andere —
        // sonst saessen gesetzte und vorgeschlagene Marken in
        // einer Liste um einen Pixel versetzt.
        vorschlag
          ? "border-border text-text-tertiary border-dashed bg-transparent"
          : "border-border-subtle bg-bg-secondary text-text-secondary",
        className,
      )}
    >
      {children}
    </span>
  );
}

/**
 * Dieselbe Marke fuer eine Kostenart — sie loest nur noch die
 * alten MOCO-Schluessel in ihren deutschen Namen auf
 * (`software` → „Software").
 */
export function CategoryTag({
  category,
  vorschlag,
  title,
  className,
}: {
  category: string;
  vorschlag?: boolean;
  title?: string;
  className?: string;
}) {
  return (
    <Tag vorschlag={vorschlag} title={title} className={className}>
      {categoryLabel(category)}
    </Tag>
  );
}
